'use client';

import { __awaiter, __generator, __assign } from '../_virtual/_tslib.js';
import { DEFAULT_SUCCESS_CODE } from '../QuickApplyJobModal/type.js';
import { encrypt } from '../Utils/helpers.js';
import { WS_TOKEN, JS_TOKEN, JS_ALL_TOKEN, USER_COOKIE, VNW_NEW_REGISTERED } from './constants.js';
import { secureUrl } from './helper.js';

var apiGetCSRFToken = function () { return __awaiter(void 0, void 0, void 0, function () {
    var API_GET_CSRF_TOKEN, response, repsonseJson, ex_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                API_GET_CSRF_TOKEN = "".concat(secureUrl(), "/api/v1/getCsrfToken");
                return [4 /*yield*/, fetch(API_GET_CSRF_TOKEN)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                repsonseJson = _a.sent();
                return [2 /*return*/, {
                        code: repsonseJson.code,
                        jwtToken: repsonseJson.jwt_token,
                        csrfToken: repsonseJson.csrf_token
                    }];
            case 3:
                ex_1 = _a.sent();
                console.error(ex_1);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
var apiDoLogin = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var username, password, csrfToken, jwtToken, langCode, headers, formData, LOGIN_API, requestOptions, response, responseJson, ex_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                username = params.username, password = params.password, csrfToken = params.csrfToken, jwtToken = params.jwtToken, langCode = params.langCode;
                headers = new Headers();
                headers.append('X-XSRF-TOKEN', csrfToken);
                headers.append('X-JWT-TOKEN', jwtToken);
                headers.append('Accept-Language', langCode);
                formData = new FormData();
                formData.set('username', username);
                formData.set('password', password);
                LOGIN_API = "".concat(secureUrl(), "/api/v1/login");
                requestOptions = {
                    method: 'POST',
                    headers: headers,
                    body: formData
                };
                return [4 /*yield*/, fetch(LOGIN_API, requestOptions)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                responseJson = _a.sent();
                if (!responseJson) {
                    return [2 /*return*/, null];
                }
                return [2 /*return*/, {
                        code: (responseJson === null || responseJson === void 0 ? void 0 : responseJson.code) || 400,
                        message: (responseJson === null || responseJson === void 0 ? void 0 : responseJson.message) || '',
                        accessToken: (responseJson === null || responseJson === void 0 ? void 0 : responseJson.access_token) || '',
                        refreshToken: (responseJson === null || responseJson === void 0 ? void 0 : responseJson.refresh_token) || '',
                        expiresIn: (responseJson === null || responseJson === void 0 ? void 0 : responseJson.expires_in) || 0,
                        wsToken: responseJson[WS_TOKEN] || '',
                        jsToken: responseJson[JS_TOKEN] || '',
                        jsAllToken: responseJson[JS_ALL_TOKEN] || '',
                        userCookie: responseJson[USER_COOKIE] || '',
                        newRegistered: responseJson[VNW_NEW_REGISTERED] || false,
                        scope: (responseJson === null || responseJson === void 0 ? void 0 : responseJson.scope) || ''
                    }];
            case 3:
                ex_2 = _a.sent();
                console.error(ex_2);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
var apiGetUserInfoFromToken = function (jsToken, wsToken) { return __awaiter(void 0, void 0, void 0, function () {
    var GET_INFO_FROM_TOKEN, response, responseData, user, ex_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                if (jsToken === '') {
                    console.error('Missing jsToken');
                    return [2 /*return*/, null];
                }
                if (wsToken === '') {
                    console.error('Missing wsToken');
                    return [2 /*return*/, null];
                }
                GET_INFO_FROM_TOKEN = "".concat(secureUrl(), "/api/v1/users/get-info-from-token");
                return [4 /*yield*/, fetch(GET_INFO_FROM_TOKEN, {
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/vnd.api+json',
                            Accept: 'application/vnd.api+json'
                        },
                        body: JSON.stringify({ jsToken: jsToken, wsToken: wsToken })
                    })];
            case 1:
                response = _a.sent();
                if (response.status !== DEFAULT_SUCCESS_CODE) {
                    return [2 /*return*/, null];
                }
                return [4 /*yield*/, response.json()];
            case 2:
                responseData = _a.sent();
                user = responseData.data[0];
                return [2 /*return*/, __assign(__assign(__assign({}, user.id), user.attributes), { accessToken: encrypt(user.attributes.accessToken) })];
            case 3:
                ex_3 = _a.sent();
                console.error(ex_3);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
var apiVerifyAuthToken = function (authToken) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, VERIFY_AUTH_TOKEN_API, requestOptions, response, responseJson, ex_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                headers = new Headers();
                headers.append('Content-Type', 'application/json');
                VERIFY_AUTH_TOKEN_API = "".concat(secureUrl(), "/api/v1/users/verify-auth-token");
                requestOptions = {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify({
                        auth_token: authToken
                    })
                };
                return [4 /*yield*/, fetch(VERIFY_AUTH_TOKEN_API, requestOptions)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()
                    // Reponse error
                ];
            case 2:
                responseJson = _a.sent();
                // Reponse error
                if (!responseJson) {
                    return [2 /*return*/, null];
                }
                // Response success failed
                if (!responseJson.success) {
                    return [2 /*return*/, null];
                }
                return [2 /*return*/, {
                        wsToken: responseJson.data[WS_TOKEN] || '',
                        jsToken: responseJson.data[JS_TOKEN] || '',
                        jsAllToken: responseJson.data[JS_ALL_TOKEN] || '',
                        userCookie: responseJson.data[USER_COOKIE] || ''
                    }];
            case 3:
                ex_4 = _a.sent();
                console.error(ex_4);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };

export { apiDoLogin, apiGetCSRFToken, apiGetUserInfoFromToken, apiVerifyAuthToken };
//# sourceMappingURL=services.js.map
